module.exports = __webpack_public_path__ + "img/why-tactical-img.31679661.svg";